exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Services_container_3yI0 {\n  margin-top: 25px;\n  padding-top: 20px;\n\n  border-top: 1px solid #d4d4d4;\n}\n\n.Services_message_1exP {\n  padding: 50px 0 30px;\n\n  text-align: center;\n}\n\n.Services_catalogLink_cVNP {\n  padding: 30px 0 10px;\n\n  text-align: center;\n}\n\n.Services_icon_7aAG {\n  margin-bottom: 10px;\n}\n\n.Services_preloaderWrapper_2uts {\n  margin: 50px;\n\n  text-align: center;\n}\n\n.Services_preloader_rrIQ {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n\n.Services_blockMessage_3enC {\n  font-size: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "Services_container_3yI0",
	"message": "Services_message_1exP",
	"catalogLink": "Services_catalogLink_cVNP",
	"icon": "Services_icon_7aAG",
	"preloaderWrapper": "Services_preloaderWrapper_2uts",
	"preloader": "Services_preloader_rrIQ",
	"blockMessage": "Services_blockMessage_3enC"
};